import * as React from "react";
import { Filter, TextInput } from 'react-admin';
import { List, Datagrid, TextField, BooleanField, DateField, useLocaleState } from 'react-admin';
import { PointOfInterestCategoryEdit } from "./pointOfInterestCategory.edit.component";

const PointOfInterestCategoryFilter = props => (
    <Filter {...props}>
        <TextInput source="q" alwaysOn resettable />
    </Filter>
);

export const PointOfInterestCategoryList = () => {
    const [locale] = useLocaleState();

    return (
        <List
            filters={<PointOfInterestCategoryFilter />}
            exporter={false}
            actions={false}
        >
            <Datagrid rowClick="edit" expand={<PointOfInterestCategoryEdit/>} bulkActionButtons={false}>
                <BooleanField source="isListed" />
                <TextField source={`name.${locale}`} label="resources.poicategories.fields.name" />
                <DateField source="createdAt" options={{ day: '2-digit', month: 'short', year: 'numeric' }} />
                <DateField source="updatedAt" options={{ day: '2-digit', month: 'short', year: 'numeric' }} />
            </Datagrid>
        </List>
    );
}